import React from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';
import MainLayout from '../../layout/MainLayout';
import JobMonitor from '../../components/olymp/JobMonitor';

/**
 * MappingJobMonitorPage (#96)
 * Route-Ziel, auf das OmopMappingBatchStartDialog nach dem Start eines
 * Mapping-Batches verweist -- bettet den bereits vorhandenen JobMonitor
 * (#97) unter einer eigenen URL ein, statt Fortschritt im Start-Dialog
 * selbst zu zeigen (Nicht-Ziel von #96).
 */
const MappingJobMonitorPage = () => {
  const { t } = useTranslation();
  const { jobId } = useParams();

  return (
    <MainLayout>
      <Box sx={{ mb: 2 }}>
        <Button component={RouterLink} to="/catalog" startIcon={<ArrowBackIcon />}>
          {t('mappingJobMonitorPage.back')}
        </Button>
      </Box>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        {t('mappingJobMonitorPage.title')}
      </Typography>
      <JobMonitor jobId={jobId} />
    </MainLayout>
  );
};

export default MappingJobMonitorPage;
